import { LoadingSpinner } from '@cfs-fixings/shared'
import UtilisationPercentagePill from '../../utilisation/components/UtilisationPercentagePill'

type PropTypes = {
  isLoading?: boolean
  tensionUtilisation?: number | null | undefined
  shearUtilisation?: number | null | undefined
  combinedUtilisation?: number | null | undefined
}

const Utilisation = ({ utilisation }: { utilisation: number | null | undefined }) => {
  return (
    <>
      {
        (utilisation ?? 0) > 0
          ? (
            <UtilisationPercentagePill
              percentage={utilisation ?? 0}
            />
          )
          : (
            <p className="text-xs font-semibold leading-[18px] text-gray-550">
              Incomplete / Invalid
            </p>
          )
      }
    </>
  )
}

const ProductValidation = ({ isLoading = false, tensionUtilisation, shearUtilisation, combinedUtilisation } : PropTypes) => {
  return (
    <div className="flex items-center pt-4 h-[44px]">
      {
        isLoading
          && <LoadingSpinner className="h-4 w-4" />
      }
      {
        !isLoading
          && (
            <div className="flex flex-row justify-center items-center">
              <p className="text-xs font-medium leading-[18px] pr-3 text-gray-550">Tension Evaluation</p>
              <Utilisation utilisation={tensionUtilisation} />
              <p className="text-xs font-medium leading-[18px] pr-3 pl-8 text-gray-550">Shear Evaluation</p>
              <Utilisation utilisation={shearUtilisation} />
              <p className="text-xs font-medium leading-[18px] pr-3 pl-8 text-gray-550">Combined Evaluation</p>
              <Utilisation utilisation={combinedUtilisation} />
            </div>
          )
      }
    </div>
  )
}

export default ProductValidation
